import api from "@/lib/api";

// -------- Service Worker registration --------
export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/leadify-sw.js");
    return reg;
  } catch (e) {
    console.error("SW registration failed", e);
    return null;
  }
}

// -------- Base64 helpers for VAPID key --------
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

// -------- Push subscribe / unsubscribe --------
export async function enablePushNotifications() {
  if (!("Notification" in window)) throw new Error("Notifications not supported");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission denied");

  const reg = await registerServiceWorker();
  if (!reg) throw new Error("Service worker unavailable");

  const { data: vapid } = await api.get("/push/public-key");
  if (!vapid.public_key) throw new Error("Push not configured on server");

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapid.public_key),
  });
  const subJson = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
  return { ok: true, subscription: subJson };
}

export async function disablePushNotifications() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    const j = sub.toJSON();
    await api.post("/push/unsubscribe", { endpoint: j.endpoint });
    await sub.unsubscribe();
  }
}

export async function isPushSubscribed() {
  if (!("serviceWorker" in navigator)) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager.getSubscription();
    return !!sub;
  } catch { return false; }
}

// -------- Foreground Notification helper --------
export function showLocalNotification(title, body, link = "/") {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg) reg.showNotification(title, { body, icon: "/favicon.ico", data: { link }, tag: "leadify-fg" });
    else new Notification(title, { body, icon: "/favicon.ico" });
  });
}
